import ManageSignatureContainer from './manageSignatureContainer';
export default ManageSignatureContainer;
